export const ROUTE_NAMES = [
  "HOME",
  // 読みもの(/articles/。日本語のページだけ下部タブに出す。plan/59)
  "READING",
  "DISCOGRAPHY",
  "LIVE",
  "PLACE",
  "PHOTO",
  // "TIMELINE"
];
